module.exports = __webpack_public_path__ + "static/media/scripps_logo.fbcdb93a.svg";